import {
  FilterCategory,
  FilterManager,
  FilterOption,
  FilterState,
} from "../types/filterManager";
import { truthyPredicate } from "@pairtreefamily/utils";

export const excludeDraftsFilter: string = "!(_id in path('drafts.**'))";

export function getExcludeDraftsFilter(preview?: boolean): string {
  if (preview) {
    return "true";
  } else {
    return excludeDraftsFilter;
  }
}

// names are hard :(
// this creates a groq filter based on user-selected filters
export function getFilterStateFilter(filters?: FilterState): string {
  const filterManager = new FilterManager(filters);
  const hasFilterSelections = filterManager.getSelectedOptions().length > 0;

  if (!hasFilterSelections) {
    return "true";
  }

  const getOptionFilter = (option: FilterOption): string => {
    // assumes that the document has a field named `option.category`
    return `"${option.value}" in ${option.category}[]->value`;
  };

  const getCategoryFilter = (category: FilterCategory): string => {
    const selectedOptions = filterManager.getSelectedOptions(category.value);
    if (selectedOptions.length === 0) {
      return "";
    }
    return `(${selectedOptions.map(getOptionFilter).join(" || ")})`;
  };

  const filterCategories = filterManager.getCategories();
  const filterExpressions = `${
    filterCategories
      .map(getCategoryFilter)
      .filter(truthyPredicate)
      .join("\n && ") // newline not required for query, but way more readable when inspecting
  }`;

  return filterExpressions;
}
